import React from "react";

const PasswordCheckBox = (props) => (
  <div className="password_check_box">
    <ul>
      <li className={props.isValidLength ? "success" : ""}>
        Minimum of 8 characters
      </li>
      <li className={props.hasNumber ? "success" : ""}>At least 1 Number</li>
      <li className={props.isUpperCase ? "success" : ""}>
        At least 1 Uppercase
      </li>
      <li className={props.isLowerCase ? "success" : ""}>
        At least 1 Lowercase
      </li>
    </ul>
  </div>
);

export default PasswordCheckBox;
